import { render } from "./PosCard.vue?vue&type=template&id=232718c4&scoped=true"
import script from "./PosCard.vue?vue&type=script&lang=js"
export * from "./PosCard.vue?vue&type=script&lang=js"

import "./PosCard.vue?vue&type=style&index=0&id=232718c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-232718c4"]])

export default __exports__